import { FC, ForwardedRef, forwardRef, PropsWithChildren } from 'react';

import styles from './RefTextInput.module.scss';

type Props = any;
// eslint-disable-next-line react/display-name
const RefTextInput: FC<Props> = forwardRef((props: PropsWithChildren<Props>, ref: ForwardedRef<any>) => {
  const { children, size, ...inputProps } = props;

  return <input className={`${styles.input_item} ${size}`} ref={ref} {...inputProps} />;
});

export default RefTextInput;
